export default "__VITE_ASSET__BYDbRiYt__"